"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
var paramRegex = exports.paramRegex = /\/(:([^\/?]*)\??)/g;
var optionalRegex = exports.optionalRegex = /(\/:[^\/]*\?)$/g;